import {
  isAzureAuthEnabled,
  loginWithAzureAD,
} from '../../services/azureAuthService';
import {
  isMsalConfigured,
  loginWithMicrosoftRedirect,
} from '../../services/msalAuthService';

const LOCAL_RUNTIME_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);
const ENABLED_FLAG_VALUES = new Set(['1', 'true', 'yes', 'on']);

const isLocalDevelopmentRuntime = () => {
  if (typeof window === 'undefined') {
    return process.env.NODE_ENV === 'development';
  }

  const hostname = (window.location.hostname || '').toLowerCase();
  return process.env.NODE_ENV === 'development' || LOCAL_RUNTIME_HOSTS.has(hostname);
};

const isLocalAuthFallbackEnabled = () => {
  const explicitFlag = (
    process.env.REACT_APP_ENABLE_LOCAL_AUTH || ''
  ).toLowerCase();
  if (ENABLED_FLAG_VALUES.has(explicitFlag)) {
    return true;
  }

  const frontendFlaskEnv = (process.env.REACT_APP_FLASK_ENV || '').toLowerCase();
  return frontendFlaskEnv === 'development';
};

const getPublicAuthMode = () => {
  const msalEnabled = isMsalConfigured();
  const azureEnabled = isAzureAuthEnabled();
  const microsoftManaged = msalEnabled || azureEnabled;
  const localDevelopment = isLocalDevelopmentRuntime();
  const canUseLocalCredentials =
    localDevelopment && !microsoftManaged && isLocalAuthFallbackEnabled();

  return {
    msalEnabled,
    azureEnabled,
    microsoftManaged,
    localDevelopment,
    canUseLocalCredentials,
    canSelfRegister: canUseLocalCredentials,
    canStartMicrosoftSignIn: microsoftManaged,
    statusLabel: microsoftManaged
      ? 'Microsoft-managed access'
      : canUseLocalCredentials
        ? 'Local development fallback'
        : localDevelopment
          ? 'Local auth fallback disabled'
          : 'Provisioned access required',
  };
};

const beginMicrosoftSignIn = async () => {
  if (isMsalConfigured()) {
    return loginWithMicrosoftRedirect();
  }

  if (isAzureAuthEnabled()) {
    return loginWithAzureAD();
  }

  throw new Error(
    'Microsoft sign-in is not configured for this environment. Contact an Island Millwork administrator.',
  );
};

export { beginMicrosoftSignIn, getPublicAuthMode, isLocalDevelopmentRuntime };
